module.exports = __webpack_public_path__ + "static/media/builtinv2-rosetki 2.1f8cbe62.png";